import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { SnackbarContext } from "../../../../contexts/Snackbar";
import { returnSubmit } from "../../../../enums/queryFunction/Submit";
//keys
/**
 *  PETS,
    PETS + "user" + "user_id",
    PETS_DROP_DOWN
 */

export default function useSubmitPet(url, key) {
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const [loading, setLoading] = React.useState(false);
  const queryClient = useQueryClient();

  const queryKey = key;

  const submitCallback = async (obj) => {
    setLoading(true);
    mutate(obj); // Pass the `replaceData` flag to the mutation
  };

  function updateKey(key, response) {
    queryClient.setQueryData([key], (oldData) => {
      if (!oldData) {
        return [...[], response?.data];
      }
      const returnArry = [...oldData, response?.data];
      return returnArry;
    });
  }

  const { mutate } = useMutation({
    mutationFn: (data) => returnSubmit(url, data),
    onSuccess: () => {
      queryClient.invalidateQueries([queryKey]);
      handleSnackbar("successMessage", "success");
      setLoading(false);
    },
    onError: (error) => {
      handleSnackbar("errorMessage", "error");
      setLoading(false);
    },
  });

  return {
    submitCallback,
    loading,
  };
}
